var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ce-paragraph"},[_c('div',{ref:"editable",staticClass:"ce-in",attrs:{"placeholder":"Enter Text Here...","contenteditable":"true"},on:{"keydown":_vm.onKeyDown,"blur":_vm.update}})])}
var staticRenderFns = []

export { render, staticRenderFns }